import { render, staticRenderFns } from "./canned-report-grid.vue?vue&type=template&id=ff21740e&scoped=true&"
import script from "./canned-report-grid.vue?vue&type=script&lang=js&"
export * from "./canned-report-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff21740e",
  null
  
)

export default component.exports